var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalanderActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 174",
    d: "M1 6.44711H12.7984",
    stroke: "#DE1186",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1244",
    d: "M10.1189 2.54147H11.0084C11.5367 2.54169 12.0433 2.7517 12.4168 3.12532C12.7902 3.49894 13 4.00559 13 4.53386V11.8564C13 12.3847 12.7902 12.8914 12.4168 13.265C12.0433 13.6386 11.5367 13.8486 11.0084 13.8488H2.99152C2.46353 13.8482 1.95739 13.638 1.58428 13.2644C1.21116 12.8908 1.00159 12.3844 1.00159 11.8564V4.53386C1.00159 4.00587 1.21116 3.49947 1.58428 3.1259C1.95739 2.75232 2.46353 2.54212 2.99152 2.54147H10.1189Z",
    stroke: "#DE1186",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 175",
    d: "M4.63687 1V4.08293",
    stroke: "#DE1186",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 176",
    d: "M9.36389 1V4.08293",
    stroke: "#DE1186",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderActiveIcon);
export default __webpack_public_path__ + "static/media/calander-active-icon.29b5b01e07c237fcd2cd611cc95db8d3.svg";
export { ForwardRef as ReactComponent };